import * as req from 'api/actions';
import * as c from './constant';

// special permit get Listing
export const getTransactionList = (payload = { module_type: 'SPECIAL_PERMIT' }, callback) =>
  req.list(
    c.GET_TRANSACTION,
    '/api/v1/administrators/transaction_histories/special_permits',
    payload,
    callback
  );

export const showTransaction = (id, payload, callback) =>
  req.item(
    c.SHOW_TRANSACTION,
    `/api/v1/administrators/transaction_histories/special_permits/${id}`,
    payload,
    callback
  );

export const clearTransaction = () => req.setList(c.GET_TRANSACTION, []);

export const assessReceipt = (id, payload, callback) =>
  req.update(
    c.ASSESS_RECEIPT,
    `/api/v1/administrators/transaction_histories/${id}/assess_payment_receipt`,
    payload,
    callback,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const generatePermit = (id, payload, callback) =>
  req.create(
    c.GENERATE_PERMIT,
    `api/v1/administrators/transaction_histories/special_permits/${id}/generate_permit`,
    payload,
    callback
  );

export const toggleAssessment = (id, payload, callback) =>
  req.update(
    c.TOGGLE_ASSESSMENT,
    `/api/v1/administrators/transaction_histories/${id}/start_assessment`,
    payload,
    callback
  );

export const tagVehicleUnit = (id, payload, callback) =>
  req.update(
    c.TAG_VEHICLE_UNIT,
    `/api/v1/administrators/transaction_histories/special_permits/vehicle_unit/${id}`,
    payload,
    callback
  );

export const submitAssessment = (id, payload, callback) =>
  req.update(
    c.SUBMIT_ASSESSMENT,
    `/api/v1/administrators/transaction_histories/${id}/submit_assessment`,
    payload,
    callback
  );

export const updateFees = (id, payload, callback) =>
  req.update(
    c.UPDATE_FEES,
    `/api/v1/administrators/transaction_histories/special_permits/${id}/update_fees`,
    payload,
    callback
  );

  export const tagAsPrintedTransaction = (id, payload, callback) =>
  req.update(
    c.TAG_AS_PRINTED_TRANSACTION,
    `api/v1/administrators/transaction_histories/special_permit/${id}/tag_as_printed`,
    payload,
    callback
  );

  export const tagAsReceivedTransaction = (id, payload, callback) =>
  req.update(
    c.TAG_AS_RECEIVED_TRANSACTION,
    `api/v1/administrators/transaction_histories/special_permit/${id}/tag_as_received`,
    payload,
    callback
  );
